import { useAppSelector } from '../useAppSelector';

export const useOffices = () => {
  const offices = useAppSelector((state) => state.user.offices);

  return {
    offices,
    hasOffices: offices?.length > 0,
  };
};
